<template>
  <modal
    @close_modal="close"
    :title="$t('models_and_train_configs.view_images')"
  >
    <template v-slot:content>
      <div v-if="!images.length" class="text--secondary">
        {{ $t('models_and_train_configs.view_images_empty') }}
      </div>
      <div v-else class="gallery">
        <div class="gallery__main">
          <img
            :src="activeImage.path"
            :alt="activeImage.name"
            class="gallery__main-image"
          />
        </div>
        <div class="gallery__thumbs" ref="thumbs">
          <button
            v-for="(image, index) in images"
            :key="image.path"
            type="button"
            class="gallery__thumb"
            :class="{ 'gallery__thumb--active': index === activeIndex }"
            @click="activeIndex = index"
          >
            <img :src="image.path" :alt="image.name" />
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Modal';

export default {
  name: 'ModelImageGallery',
  components: { Modal },
  props: {
    images: { type: Array, required: true },
    initialIndex: { type: Number, default: 0 },
  },
  data() {
    return {
      activeIndex: this.initialIndex,
    };
  },
  computed: {
    activeImage() {
      return this.images[this.activeIndex] || this.images[0];
    },
  },
  mounted() {
    window.addEventListener('keydown', this.onKeydown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeydown);
  },
  watch: {
    activeIndex() {
      this.scrollActiveThumbIntoView();
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onKeydown(event) {
      if (!this.images.length) {
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.selectPrevious();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.selectNext();
      }
    },
    selectPrevious() {
      if (this.activeIndex > 0) {
        this.activeIndex -= 1;
      }
    },
    selectNext() {
      if (this.activeIndex < this.images.length - 1) {
        this.activeIndex += 1;
      }
    },
    scrollActiveThumbIntoView() {
      this.$nextTick(() => {
        const container = this.$refs.thumbs;
        const activeThumb = container?.children?.[this.activeIndex];
        activeThumb?.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
      });
    },
  },
};
</script>

<style scoped>
.gallery {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 50vh;
}
.gallery__main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: min(60vh, 520px);
  background: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  overflow: hidden;
}
.gallery__main-image {
  max-width: 100%;
  max-height: min(60vh, 520px);
  width: auto;
  height: auto;
  object-fit: contain;
}
.gallery__thumbs {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding: 4px 2px 2px;
}
.gallery__thumb {
  flex: 0 0 auto;
  width: 72px;
  height: 72px;
  padding: 0;
  border: 2px solid transparent;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.06);
  cursor: pointer;
  overflow: hidden;
}
.gallery__thumb--active {
  border-color: #1976d2;
}
.gallery__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>
